import { h } from "../core/dom.js";

// One-time storage notice. Kashtu uses ONLY strictly-necessary local storage (the sign-in
// token + your preferences) and no tracking/advertising cookies, so under GDPR/ePrivacy
// (in Germany, § 25 TDDDG) this is an informational notice, not a consent gate — there's
// nothing to reject. We show it once and remember the dismissal in localStorage.
const KEY = "wt_cookie_notice";

export function maybeShowCookieNotice() {
  try {
    if (localStorage.getItem(KEY) === "1") return;
  } catch {
    return; // storage blocked — don't nag (and we couldn't remember a dismissal anyway)
  }

  const dismiss = () => {
    try { localStorage.setItem(KEY, "1"); } catch {}
    bar.remove();
  };

  const bar = h(
    "div",
    { class: "cookie-notice", role: "region", "aria-label": "Storage notice" },
    h(
      "p",
      null,
      "Kashtu uses only strictly-necessary local storage to keep you signed in and remember your settings — ",
      "no tracking or advertising cookies. ",
      // data-link is intercepted by the router's global click handler (no full reload).
      h("a", { href: "/privacy", "data-link": "/privacy" }, "Privacy Policy")
    ),
    h("button", { class: "btn btn-primary", onClick: dismiss }, "Got it")
  );
  document.body.appendChild(bar);
}
